import Vue from 'vue'
import has from '@/directives/has'
import drag from './drag'
import loadmore from './loadmore'
require("./singleclick")
Vue.directive('has', has)
Vue.directive('drag', {
    inserted: drag
})
Vue.directive('el-select-loadmore', loadmore)
